const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 13/12/16.
 */

const React = require('react');
const Activity = require('./Activity/Activity');
const WorkType = require('./WorkType/WorkType');
const WorkersData = require('./WorkersData/WorkersData');
const CompanyData = require('./CompanyData/CompanyData');
require('./LaboralData.scss');

const mockHelper = require('../../utilities/mockDataHelper');

class LaboralData extends React.Component {

    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values) {
            initialState = this.props.values[0];
        } else {
            initialState = {
                workType: 1,
                activity: 1,
                component_id: 'laboralData'
            };
        }
        this.state = initialState;
        this.onHandleWorkTypeChange = this.onHandleWorkTypeChange.bind(this);
        this.onHandleActivityChange = this.onHandleActivityChange.bind(this);
        this.renderCurrentForms = this.renderCurrentForms.bind(this);
        this.onDataReceiver = this.onDataReceiver.bind(this);
        this.getNotice = this.getNotice.bind(this);
    }


    onDataReceiver(data) {
        //Here data contains an array with the values of the form depending user selection
        //In case that the selected option is CUENTA_AJENA, data is an array with :
        //  * The first element have the data of company data
        // * The second element is an array with the values of OtherIncome
        this.props.dataReceiver([this.state, data]);
    }

    onHandleActivityChange(activityId) {
        this.setState({activity: activityId.value});
    }

    onHandleWorkTypeChange(worktype) {
        this.setState({workType: worktype.value});
    }

    getNotice() {
        return (
            <div className="laboral-data__not-work-notice">
                <p>Si eres estudiante / ama de casa y no tienes ingresos deberás incluir también los datos de tus padres o personas con ingresos que junto contigo vayan a ser avalistas o titulares del préstamo. Agrega un avalista o titular para estudiar si la operaciónes viable</p>
            </div>
        )
    }

    getOptionValues() {
        let values;
        if (this.props.values != null) {
            if (Array.isArray(this.props.values[1])) {
                values = {};
            } else {
                values = this.props.values[1];
            }
        } else {
            values = {};
        }

        return values;
    }

    renderCurrentForms() {
        switch (this.state.workType) {
            case mockHelper.workTypeValues.NO_TRABAJAS:
                switch (this.state.activity) {
                    case mockHelper.activitiesValuesYouDontWork.AMA_DE_CASA:
                    case mockHelper.activitiesValuesYouDontWork.ESTUDIANTE:
                        return this.getNotice();
                    default:
                        let values = this.getOptionValues();
                        return (<WorkersData
                            values={values}
                            dataReceiver={this.onDataReceiver}/>);
                }
            case mockHelper.workTypeValues.CUENTA_PROPIA:
            case mockHelper.workTypeValues.EMPRESARIO:
                let values = this.getOptionValues();
                return (<WorkersData
                    values={values}
                    dataReceiver={this.onDataReceiver}/>);
            case mockHelper.workTypeValues.CUENTA_AJENA:
                let val;
                if (this.props.values){
                    if (Array.isArray(this.props.values[1])) {
                        val = this.props.values[1];
                    } else {
                        val = [{}, []];
                    }
                } else  {
                    val = [{}, []];
                }

                return (<CompanyData
                    values={val}
                    dataReceiver={this.onDataReceiver}/>);
        }
    }

    render() {
        return (
            <div>
                <div className="laboral-data">
                    <div className="laboral-data__worktype">
                        <WorkType
                            handleOnChange={this.onHandleWorkTypeChange}
                            selectedWorkType={this.state.workType}/>
                    </div>
                    <div className="laboral-data__activity">
                        <Activity
                            handleOnChange={this.onHandleActivityChange}
                            selectedActivity={this.state.activity}
                            workType={this.state.workType}/>
                    </div>
                </div>
                <div>
                    {this.renderCurrentForms()}
                </div>
            </div>


        );
    }
}

LaboralData.propTypes = {
    values: PropTypes.any,
    dataReceiver: PropTypes.func
};

module.exports = LaboralData;